export const Role = {
  GAdmin: 'Global Administrator',
  Admin: 'Administrator',
  Frontline: 'FrontLine',
  ITAdmin: 'IT Administrator',
  Operator: 'Operator',
  Manager: 'Manager',
  Billing: 'Billing',
  Customer: 'Customer',
  ServiceAssurance: 'Service Assurance'
}
